export default __webpack_public_path__ + "static/media/logo_light_nodonpro.1fe7ac53.svg";